var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-image-wrapper bg-white rounded d-flex justify-content-center p-2"},[_c('WCImage',{attrs:{"imageSrc":_vm.imageSrc,"imageAlt":_vm.alt,"defaultClass":"w-100 h-100","defaultTitle":_vm.defaultTitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }